/* eslint-disable @typescript-eslint/no-explicit-any */
import { get } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import Definitions from '../Definitions';

const definitions = Definitions.CheckUpdateMemberStatus;

const callGet = async (): Promise<IFinalResponse> => {
  const init: InitApiType = {};
  return get(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};
const call = { get: callGet };

export default { call, definitions };
